import { useCallback, useContext, useState } from "react";
import CircularIndeterminate from "../../../components/CircularIndeterminate/CircularIndeterminate";
import { AuthContext } from "../../../lib/context/AuthContext";
import CompaniesCards from "./CompaniesCards/CompaniesCards";
import CoverSection from "./CoverSection/CoverSection";
import { Description, MainWrapper, SectionWrapper, Title } from "./styles";
import { Trans, useTranslation } from "react-i18next";
import { Container } from "@mui/material";
import JobAdsBoard from "../JobAds/JobAdsBoard";
import { LogoAsset } from "./types";

export default function Home() {
  const { user, isAuthenticated, loading } = useContext(AuthContext);
  const shouldDisplay = !isAuthenticated || user?.candidateId;
  const { t } = useTranslation();
  const [jobLogos, setJobLogos] = useState<LogoAsset[]>([]);

  const handleVisibleLogosChange = useCallback((logos: LogoAsset[]) => {
    setJobLogos(logos);
  }, []);

  if (loading) return <CircularIndeterminate />;
  return (
    <>
      <CoverSection showSearch={false} />
      <Container>
        <MainWrapper>
          <Title>{t("home.what_it_is.title")}</Title>
          <Description>
            <Trans
              i18nKey="home.what_it_is.description"
              values={{
                name: `<span>${t("home.what_it_is.name")}</span>`,
              }}
              components={{
                span: (
                  <span style={{ color: "#72C2CC", fontWeight: "bolder" }} />
                ),
              }}
            />
          </Description>
        </MainWrapper>
      </Container>
      <SectionWrapper $background="#F5F8FF">
        <JobAdsBoard onVisibleLogosChange={handleVisibleLogosChange} />
      </SectionWrapper>
      {shouldDisplay && (
        <SectionWrapper $background="#FDF6FF">
          <CompaniesCards logos={jobLogos} />
        </SectionWrapper>
      )}
    </>
  );
}
